export default __webpack_public_path__ + "static/bgImageSBLg-12512934c7a762ed96273090c399b182.png";